import { userAction, userState } from "./types";
import { actions } from './actions';

export function userStoreReducer(state: userState, action: userAction): userState {
	switch (action.type) {
		case 'SET_USER':
			return actions.setUser(action.payload);

		case 'SET_AVATAR_SRC':
			return actions.setAvatarSrc(state, action.payload);
		default:
			throw new Error('Unexpected action');
	}
}
